import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(core)/error.tsx");
